module.exports = __webpack_public_path__ + "static/image-7a19aad24c094f9a7eaff1b21b8108f0.jpg";